import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AppEmbed, Page } from '@thoughtspot/visual-embed-sdk/react';
import { EmbedContainer } from './Container';
import { APP_EMBED_FEATURE_FLAGS } from '../../constants';

interface FullAppProps {
  urlPath: string;
  embedRef: any;
  variables: any;
  embedSelections: any;
}

export const AppEmbedBase = ({ embedRef, variables, embedSelections }: FullAppProps) => {
  const [pageId, setPageId] = useState(null as Page | null);

  useEffect(() => {
    if (embedSelections.pageId) {
      setPageId(embedSelections.pageId);
    } else {
      setPageId(Page.Home);
    }
  }, [embedSelections.pageId]);

  return pageId ? (
    <AppEmbed
      frameParams={{
        height: '100%',
      }}
      className="embed-content"
      pageId={pageId}
      ref={embedRef}
      {...APP_EMBED_FEATURE_FLAGS}
      customizations={{
        style: {
          customCSS: {
            variables: variables,
          },
        },
      }}
    />
  ) : null;
};

export const AppEmbedPage = (props) => {
  return <EmbedContainer EmbedComponent={AppEmbedBase} {...props} />;
};
